/* unplugin-vue-components disabled */import { render } from "./SingleSong.vue?vue&type=template&id=74d6bece&scoped=true"
import script from "./SingleSong.vue?vue&type=script&lang=js"
export * from "./SingleSong.vue?vue&type=script&lang=js"

import "./SingleSong.vue?vue&type=style&index=0&id=74d6bece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d6bece"]])

export default __exports__